import { axiosInterceptor, apiCall } from 'services'
import { API_BASE_URL } from './constants'

const cleanupService = () => {
	const api = axiosInterceptor(API_BASE_URL)

	// GET - audit unused components
	const auditComponents = async () => await apiCall(api.get('/admin/cleanup/audit'))

	// DELETE - delete a component file
	const deleteComponent = async (filePath: string) =>
		await apiCall(api.delete('/admin/cleanup/component', { data: { filePath } }))

	// DELETE - bulk delete component files
	const deleteComponents = async (filePaths: string[]) =>
		await apiCall(api.delete('/admin/cleanup/components', { data: { filePaths } }))

	return {
		auditComponents,
		deleteComponent,
		deleteComponents,
	}
}

export default cleanupService
